<template>
  <div id="forgot-password">
    <vue-headful title="Wachtwoord Vergeten" />
    <header class="w-100">
      <div class="container-fluid px-4">
        <div class="icon-wrapper derect-logo">
          <router-link :to="{ name: 'choose-branch' }" title="Inloggen" class="text-brown">
            <svg-icon icon="derect_logo"></svg-icon>
            <span>Direct een extra kracht</span>
          </router-link>
        </div>
        <p class="m-0 d-inline-block login">
          <router-link :to="{ name: 'login' }" title="Inloggen" class="text-brown">
            <svg-icon icon="person_male"></svg-icon> Inloggen
          </router-link>
        </p>
      </div>
    </header>
    <div class="d-flex">
      <div class="py-5 px-4 container-fluid margin-unset">
        <h2 class="sd-title bold white text-center large margin-bottom-2">
          Wachtwoord vergeten
        </h2>
        <form @submit.prevent="onSubmit" class="sd-container bg-white margin-bottom-0 sd-form">
          <NotificationContainer />
          <p>Vul je e-mailadres in en we sturen je een nieuw wachtwoord.</p>
          <div class="sd-input mb-4 pb-1">
            <label>E-mailadres</label>
            <input type="email" class="form-control" placeholder="E-mailadres" v-model="form.email" autocomplete="nope" required/>
          </div>
          <button type="submit" class="btn btn-warning btn-block">
            Stuur wachtwoord
          </button>
        </form>
      </div>
    </div>
    <Notification v-if="fullscreen_notif" :text="text" :link="{ name: 'login' }" button="Ok"/>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      form: {
        email: ""
      },
      text: "",
      fullscreen_notif: null
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData() {},
    onSubmit() {
      let formData = new FormData();
      formData.append("email", this.form.email);
      var url = this.$apiURI + "/auth/forgot";
      this.$http
        .post(url, formData, {
          headers: {
            Accept: "application/json"
          }
        })
        .then(success => {
          this.text = "<p>" + success.data.message + "</p>";
          localStorage.setItem(
            "user-login",
            JSON.stringify({
              email: this.form.email
            })
          );
          this.fullscreen_notif = true;
        })
        .catch(() => {
          // console.log(error);
          const notification = {
            type: "danger",
            message: "Er is een fout opgetreden.",
              error: true
          };
          this.$store.dispatch("notification/replace", notification, {
            root: true
          });
        });
    }
  }
};
</script>

<style scoped>

.margin-unset {
  margin-top: unset !important;
  margin-bottom: unset !important;
}

.margin-bottom-0 {
  margin-bottom: 0;
}

.margin-bottom-2 {
  margin-bottom: 2rem;
}

header {
  padding-top: 30px;
}

.derect-logo a {
  color: unset;
}

.derect-logo span {
  display: block;
  font-size: 10px;
  font-weight: normal;
}

</style>
